module.exports = __webpack_public_path__ + "static/media/trelloLogo.066b1254.png";